module.exports = __webpack_public_path__ + "img/kehuishouwu_icon.c6734cef.png";